import React from 'react'
import { 
	HiCheckCircle, 
	HiOutlineInformationCircle, 
	HiOutlineExclamation, 
	HiOutlineExclamationCircle 
} from 'react-icons/hi'
import { Avatar, Button, Dialog, } from 'components/ui'
import PropTypes from 'prop-types'

const StatusIcon = ({status}) => {

	switch (status) {
		case 'info':
			return (
				<Avatar className="bg-blue-100 text-blue-600 dark:bg-blue-500/20 dark:text-blue-100" shape="circle">
					<span className="text-2xl"><HiOutlineInformationCircle /></span>
				</Avatar>
			)
		case 'success':
			return (
				<Avatar className="bg-emerald-100 text-emerald-600 dark:bg-emerald-500/20 dark:text-emerald-100" shape="circle">
					<span className="text-2xl"><HiCheckCircle /></span>
				</Avatar>
			)
		case 'warning':
			return (
				<Avatar className="text-amber-600 bg-amber-100 dark:text-amber-100" shape="circle">
					<span className="text-2xl"><HiOutlineExclamationCircle /></span>
				</Avatar>
			)
		case 'danger':
			return (
				<Avatar className="text-red-600 bg-red-100 dark:text-red-100" shape="circle">
					<span className="text-2xl"><HiOutlineExclamation /></span>
				</Avatar>
			)
	
		default:
			return null
	}
}

const ConfirmDialog = props => {

	const {
		type,
		title,
		children,
		onCancel,
		onConfirm,
		cancelText,
		confirmText,
		confirmButtonColor,
		confirmButtonLoading,
		confirmButtonDisabled,
		...rest
	} = props

	const handleCancel = () => {
		if (confirmButtonLoading) return
		onCancel?.()
	}

	const handleConfirm = () => {
		if (confirmButtonLoading) return
		onConfirm?.()
	}
 
	const centeredStyle = {
		content: {
			inset: 'unset',
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			transform: 'translate(-50%, -50%)'
		}
	}

	// Cuando hay un request en vuelo, bloquear todas las vias de cierre
	// (X del header, click en backdrop, ESC). El `rest` puede sobreescribir
	// estos defaults si el caller pasa explicitamente algun valor.
	return (
		<Dialog
			className="confirm-dialog"
			style={centeredStyle}
			contentClassName="pb-0 px-0"
			closable={!confirmButtonLoading}
			shouldCloseOnOverlayClick={!confirmButtonLoading}
			shouldCloseOnEsc={!confirmButtonLoading}
			{...rest}
		>
			<div className="px-5 pt-5 pb-3 flex flex-col sm:flex-row gap-3 items-center sm:items-start text-center sm:text-left">
				<div className="flex-shrink-0">
					<StatusIcon status={type} />
				</div>
				<div className="space-y-2 sm:ml-4">
					<h5 className="text-base font-semibold text-gray-900 dark:text-gray-100">{title}</h5>
					<div className="text-sm text-gray-600 dark:text-gray-300">
						{children}
					</div>
				</div>
			</div>
			<div className="px-5 pb-3 pt-3 bg-gray-50 dark:bg-gray-700 rounded-bl-lg rounded-br-lg flex flex-col sm:flex-row sm:justify-end gap-2">
				<Button
					size="sm"
					className="w-full sm:w-auto"
					onClick={handleCancel}
					disabled={!!confirmButtonLoading}
				>
					{cancelText}
				</Button>
				<Button
					size="sm"
					variant="solid"
					onClick={handleConfirm}
					color={confirmButtonColor}
					className="w-full sm:w-auto"
					loading={!!confirmButtonLoading}
					disabled={!!confirmButtonDisabled || !!confirmButtonLoading}
				>
					{confirmText}
				</Button>
			</div>
		</Dialog>
	)
}

ConfirmDialog.propTypes = {
	type: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
}

ConfirmDialog.defaultProps = {
	type: 'info',
	cancelText: 'Cancel',
	confirmText: 'Confirm',
}


export default ConfirmDialog
